import { render, staticRenderFns } from "./ProductsBulkTable.vue?vue&type=template&id=1efc1a11&scoped=true&"
import script from "./ProductsBulkTable.vue?vue&type=script&lang=js&"
export * from "./ProductsBulkTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductsBulkTable.vue?vue&type=style&index=0&id=1efc1a11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efc1a11",
  null
  
)

export default component.exports